import { useState, useCallback } from 'react';
import { Wallet, History } from 'lucide-react';
import HeaderWalletModal from '../Layout/HeaderWalletModal';
import TransactionHistory from './TransactionHistory';
import { useClickOutside } from '../../hooks/useClickOutside';

interface WalletButtonProps {
  userId: string;
  companyId: string;
  balance: number;
  userName: string;
  userEmail: string;
}

export default function WalletButton({
  userId,
  companyId,
  balance,
  userName,
  userEmail
}: WalletButtonProps) {
  const [showOptions, setShowOptions] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const handleClose = useCallback(() => {
    setShowWalletModal(false);
  }, []);

  const handleHistoryClose = useCallback(() => {
    setShowHistory(false);
  }, []);

  const dropdownRef = useClickOutside(() => {
    setShowOptions(false);
  });

  // Verifica se tem userId válido
  const hasValidUserId = userId && userId.length > 0;

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setShowOptions(!showOptions)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <Wallet size={20} className="text-primary" />
        <span className="font-medium">€{balance.toFixed(2)}</span>
      </button>

      {showOptions && hasValidUserId && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 border border-gray-100 z-50">
          <button
            onClick={() => {
              setShowWalletModal(true);
              setShowOptions(false);
            }}
            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 w-full"
          >
            <Wallet size={16} />
            <span>Carregar</span>
          </button>
          <button
            onClick={() => {
              setShowHistory(true);
              setShowOptions(false);
            }}
            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 w-full"
          >
            <History size={16} />
            <span>Ver histórico</span>
          </button>
        </div>
      )}

      {showWalletModal && hasValidUserId && (
        <HeaderWalletModal
          isOpen={showWalletModal}
          onClose={handleClose}
          userId={userId}
          companyId={companyId}
          currentBalance={balance}
          userName={userName}
        />
      )}

      {showHistory && hasValidUserId && (
        <TransactionHistory
          isOpen={showHistory}
          onClose={handleHistoryClose}
          companyId={companyId}
          userId={userId}
        />
      )}
    </div>
  );
}
